const articles = require('./articles-news');

module.exports = articles.slice(5);
